import { render } from "./ReferralRock.vue?vue&type=template&id=0a84bace"
import script from "./ReferralRock.vue?vue&type=script&lang=js"
export * from "./ReferralRock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__